import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const i = o((a, e) => /* @__PURE__ */ s.jsx(
  t,
  {
    ref: e,
    ...a,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3664",
              width: 16,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M15.32 8.95c-.07-.17-.08-.22-.07-.34.01-.07.03-.12.07-.22.1-.25.23-.58.12-1.16-.17-.98-.97-1.56-2.14-1.56-.48 0-.69.02-.9.04-.2.02-.4.03-.92.03-.46 0-.62-.1-.64-.13a.8.8 0 0 1 .08-.41c.26-.58.77-2.08-.01-3.59C10.23.29 9.13-.12 8.34.03 7.7.16 7.26.66 7.21 1.3c-.03.49.06.84.14 1.12.09.33.17.61.05 1.28-.09.48-.3.6-.82.85-.11.06-.22.11-.33.17-1.04.56-1.55 1.34-1.95 1.97-.32.5-1.13.73-2.55.73-.41 0-.75.34-.75.75s.34.75.75.75c1.35 0 3-.16 3.81-1.42.36-.56.7-1.08 1.4-1.46.09-.05.18-.09.27-.13.57-.27 1.43-.68 1.65-1.94.18-1.01.03-1.53-.08-1.95-.06-.21-.1-.34-.09-.52.17.02.56.19.87.79.5.96.11 2-.02 2.29-.12.26-.44 1.12.04 1.85.35.54.99.81 1.9.81.59 0 .82-.02 1.05-.04.18-.02.36-.03.77-.03.6 0 .64.23.66.32.03.17.02.2-.04.36-.05.13-.12.3-.15.53-.08.53.06.89.16 1.12.07.17.08.21.06.33-.02.09-.02.1-.16.21-.19.16-.51.42-.62.94-.1.47-.06.79-.03 1.02.02.18.03.22.01.28a1 1 0 0 1-.14.13c-.28.24-.8.7-.71 1.58.01.08.01.17-.02.19-.18.2-.99.3-2.39.3-2.22 0-3.04-.64-3.83-1.27-.35-.24-.7-.52-1.12-.72-1.27-.61-3.12-.43-3.33-.41a.754.754 0 0 0 .16 1.5c.44-.05 1.76-.09 2.52.27.28.13.53.33.83.56.9.71 2.02 1.59 4.75 1.59 1.8 0 2.89-.13 3.5-.8.32-.35.45-.81.4-1.35-.01-.1-.01-.11.21-.3.17-.15.41-.36.53-.69.17-.46.13-.8.1-1.05-.02-.17-.04-.3.01-.51.01-.02.07-.06.11-.1.21-.17.57-.47.68-1.1.09-.54-.05-.91-.15-1.15"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3664)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyThumbsUpIcon";
export {
  i as AgencyThumbsUpIcon,
  i as default
};
//# sourceMappingURL=index.js.map
